import { render, staticRenderFns } from "./ChatflowSectionCard.vue?vue&type=template&id=94e21b38&scoped=true"
import script from "./ChatflowSectionCard.vue?vue&type=script&lang=js"
export * from "./ChatflowSectionCard.vue?vue&type=script&lang=js"
import style0 from "./ChatflowSectionCard.vue?vue&type=style&index=0&id=94e21b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e21b38",
  null
  
)

export default component.exports